import { AxiosInstance } from "axios";
import { ResponseDto, ResponseLSDto } from "@common/ict/model/interface/common";
import { DelistDto } from "@/zh-website/src/views/Colleges/model/interface";

export class CollegesApi {
  //除名查询
  static checkEmployeeDelisting(request: AxiosInstance, data: DelistDto) {
    return request.post<ResponseDto, ResponseLSDto>(
      "zh-business/client/v1/check-employee-exist",
      data
    );
  }
  static getTrainingNewsList(request: AxiosInstance, query) {
    return request.get<ResponseDto, ResponseDto>(
      `zh-business/client/v1/college/cooperation/dynamic/page/list`,
      {
        params: query
      }
    );
  }
  //product
  static getProductDynamic(request: AxiosInstance, query) {
    return request.get<ResponseDto, ResponseDto>(
      `/zh-business/client/v1/dynamic/page/list`,
      {
        params: query
      }
    );
  }
  static getProductCaseList(request: AxiosInstance, query) {
    return request.get<ResponseDto, ResponseDto>(
      `zh-business/client/v1/college/case/carouse/page/list`,
      {
        params: query
      }
    );
  }
  static getProductSolutionList(request: AxiosInstance, query) {
    return request.get<ResponseDto, ResponseDto>(
      `zh-business/client/v1/college/major/carouse/page/list`,
      {
        params: query
      }
    );
  }
  static getProductSolutionDetail(request: AxiosInstance, query) {
    return request.get<ResponseDto, ResponseDto>(
      `zh-business/client/v1/college/major/detail`,
      {
        params: query
      }
    );
  }
  //college cases
  static getCollegeCaseList(request: AxiosInstance, query) {
    return request.get<ResponseDto, ResponseDto>(
      `zh-business/client/v1/college/case/detail/list`,
      {
        params: query
      }
    );
  }
  //education cooperation
  static getCooperationList(request: AxiosInstance, query) {
    return request.get<ResponseDto, ResponseDto>(
      `zh-business/client/v1/college/education/cooperation/detail/list`,
      {
        params: query
      }
    );
  }
}
